import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from "react-router-dom";
import { Link } from '@material-ui/core';
import DataTable, { DataTableColumn, Order, useDataTableStyles } from '../Components/DataTable';
import { AgentUserOverviewItem } from './AgentModels';
import CreateRoundUtil from '../CreateRound/CreateRoundUtil';
import { friendlyName } from '../common/helpers/RoundHelper';
import Ticker2Util from '../Ticker2/Ticker2Util';
import { formatToCurrency } from '../common/helpers/CurrencyHelpers';

interface AgentUserTableProps {
    items: AgentUserOverviewItem[];
    onSelect? : (item : AgentUserOverviewItem) => void;
}

const AgentUserTable: React.FC<AgentUserTableProps> = (props) => {
    const classes = useDataTableStyles();
    const [selectedId, setSelectedId] = useState<number>(0);
    const [columns, setColumns] = useState<DataTableColumn<AgentUserOverviewItem>[]>([]);

    useEffect(() => {
      refreshColumns();
    }, []);
    
    const refreshColumns = () => {
      var cols: DataTableColumn<AgentUserOverviewItem>[] = [
        { id: 'id', numeric: false, disablePadding: true, label: "Id", filterEnabled: true, renderValue: it => { return (<Link component={RouterLink} to={`agentUsers/${it.id}`}>{it.id}</Link>); } },
        { id: 'agentName', numeric: false, disablePadding: false, label: 'Agent', filterEnabled: true },
        { id: 'operatorId', numeric: false, disablePadding: false, label: 'Operator', filterEnabled: true },
        { id: 'agentUserName', numeric: false, disablePadding: false, label: 'User name' },
        { id: 'createdAt', numeric: false, disablePadding: false, label: 'Created at', renderValue: item => CreateRoundUtil.toGameDateString(item.createdAt) },
        { id: 'admin', numeric: false, disablePadding: false, label: 'Admin' },
        { id: 'enabled', numeric: false, disablePadding: false, label: 'Enabled' },
        { id: 'nSyndicates', numeric: true, disablePadding: false, label: '#Syndicates' },
        { id: 'nActiveSyndicates', numeric: true, disablePadding: false, label: '#Actives' },
        { id: 'nDraftSyndicates', numeric: true, disablePadding: false, label: '#Drafts' },
        { id: 'nShares', numeric: true, disablePadding: false, label: '#Sold Shares' },
        { id: 'maxShares', numeric: true, disablePadding: false, label: '#Max shares' }
      ];
      setColumns(cols);
    }
    const onSelect = (item : AgentUserOverviewItem) => {
        setSelectedId(item.id);
        if (props.onSelect){
          props.onSelect(item);
          return;
      }
    };
  
  return (
    <DataTable columns={columns} items={props.items} getId={it => it.id} orderBy='id' order='desc' resultFilterEnabled={true} size='xsmall' onSelect={onSelect} rowsPerPage={25}  />
    );
};
  
export default AgentUserTable;
